import {IconChevronLeft, IconChevronRight} from '@sdox/icons'
import {DirectionEnum, noop, twMerge} from '@sdox/utils'

import {Button} from '..'

import type {ReactNode} from 'react'
import type {ClassNameValue} from 'tailwind-merge'

export interface ArrowControlProps {
  direction: DirectionEnum
  onClick: () => void
}

const arrowClasses: Record<DirectionEnum, ClassNameValue> = {
  left: 'left-0 ml-spacing-16',
  right: 'right-0 mr-spacing-16',
  none: '',
}

const buttonIcon: Record<DirectionEnum, ReactNode> = {
  left: <IconChevronLeft />,
  right: <IconChevronRight />,
  none: null,
}

const ariaLabel: Record<DirectionEnum, string> = {
  left: 'Nach links',
  right: 'Nach rechts',
  none: '',
}

export const ArrowControl = ({direction = DirectionEnum.RIGHT, onClick = noop}: ArrowControlProps) => (
  <div
    className={twMerge(
      'absolute top-1/2 z-10',
      arrowClasses[direction],
    )}
  >
    <Button
      leading={buttonIcon[direction]}
      onClick={onClick}
      size={'small'}
      variant={'overlay'}
      aria-label={ariaLabel[direction]}
    />
  </div>
)